import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const Sidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();

  let role = 'Clinician';
  try {
    role = JSON.parse(localStorage.getItem('user') || '{}').role || 'Clinician';
  } catch {
    /* ignore */
  }

  const clinical = [
    { id: 'dashboard', label: 'Dashboard', path: '/dashboard', icon: '/img/svg/layout-dashboard.svg' },
    { id: 'appointments', label: 'Appointments', path: '/appointments', icon: '/img/svg/calendar-check.svg' },
    { id: 'notes', label: 'Progress Notes', path: '/progress-notes', icon: '/img/svg/file-text.svg' },
    { id: 'patients', label: 'My Patients', path: '/patients', icon: '/img/svg/user-heart.svg' },
    { id: 'intake-form', label: 'Intake Forms', path: '/intake-forms', icon: '/img/svg/file-text.svg' },
  ];

  const ops = [
    { id: 'referrals', label: 'Referrals', path: '/referrals', icon: '/img/svg/user-heart.svg' },
    { id: 'messages', label: 'Inbox', path: '/messages', icon: '/img/svg/file-text.svg' },
    { id: 'tasks', label: 'Tasks', path: '/tasks', icon: '/img/svg/activity.svg' },
    { id: 'analysis', label: 'Analysis', path: '/analysis', icon: '/img/svg/activity.svg' },
    { id: 'billing', label: 'Billing', path: '/billing', icon: '/img/svg/file-invoice.svg', roles: ['Admin', 'User', 'Clinician', 'Supervisor', 'Billing'] },
    { id: 'clinical-ops', label: 'Clinical Ops', path: '/clinical-ops', icon: '/img/svg/activity.svg', roles: ['Admin', 'User', 'Clinician', 'Supervisor', 'Billing'] },
  ];

  const footer = [
    { id: 'settings', label: 'Settings', path: '/settings', icon: '/img/svg/settings.svg' },
  ];

  const allow = (item) => {
    if (role === 'Client') return ['dashboard', 'messages', 'settings'].includes(item.id);
    if (role === 'Reception') {
      return !['billing', 'clinical-ops', 'analysis', 'notes'].includes(item.id);
    }
    if (item.roles && !item.roles.includes(role) && role !== 'Admin') return false;
    return true;
  };

  const isActive = (path) =>
    location.pathname === path || location.pathname.startsWith(`${path}/`);

  const renderGroup = (label, items) => {
    const visible = items.filter(allow);
    if (!visible.length) return null;
    return (
      <div className="w-full mb-2">
        <div className="text-[8px] sm:text-[9px] uppercase tracking-wide text-white/40 mb-1 hidden sm:block px-1">
          {label}
        </div>
        <div className="space-y-1">
          {visible.map((item) => (
            <button
              key={item.id}
              type="button"
              className={`w-full max-w-[72px] sm:max-w-[100px] lg:max-w-[112px] mx-auto min-h-[44px] sm:min-h-[52px] flex flex-col items-center justify-center gap-1 rounded-xl cursor-pointer transition-all px-1 py-1.5 ${
                isActive(item.path) ? 'bg-black/30' : 'hover:bg-white/10'
              }`}
              onClick={() => navigate(item.path)}
            >
              <div className="w-5 sm:w-6 h-5 sm:h-6 flex items-center justify-center shrink-0">
                <img
                  src={item.icon}
                  alt={item.label}
                  className="w-full h-full object-contain brightness-0 invert"
                />
              </div>
              <div className="text-[9px] sm:text-[10px] font-medium leading-tight text-white hidden sm:block">
                {item.label}
              </div>
            </button>
          ))}
        </div>
      </div>
    );
  };

  return (
    <div className="fixed top-0 left-0 w-20 sm:w-28 lg:w-32 h-screen bg-dark border-r border-primary flex flex-col p-2 sm:p-3 text-center text-sm text-white font-poppins z-50">
      <div className="w-full h-full flex flex-col items-center">
        <div className="mb-3 shrink-0 w-10 sm:w-12 h-8 sm:h-9">
          <img src="/img/svg/logo.svg" alt="Logo" className="w-full h-full object-contain" />
        </div>
        <div className="flex-1 w-full overflow-y-auto overflow-x-hidden">
          {renderGroup('Clinical', clinical)}
          {renderGroup('Practice', ops)}
          {renderGroup('', footer)}
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
